"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Left = _interopRequireDefault(require("./assets/Left/Left"));
var _Right = _interopRequireDefault(require("./assets/Right"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = "figure.Ribbon {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0;\n  height: 3rem;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  position: relative;\n  max-width: 100%;\n}\nfigure.Ribbon figcaption {\n  flex: 1;\n  height: 2.5rem;\n  display: flex;\n  max-width: fit-content;\n  align-items: center;\n  text-align: center;\n  flex-wrap: nowrap;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n  background-color: #5bbc81;\n  line-height: 2rem;\n  font-weight: 700;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1rem;\n  padding: 0 1.5rem;\n  color: #262626;\n}";
  var fileName = "Ribbon_Ribbon";
  var element = document.querySelector("style[data-sass-component='Ribbon_Ribbon']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Ribbon = function Ribbon(_ref) {
  var className = _ref.className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'No Annual Fee' : _ref$children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("figure", _objectSpread(_objectSpread({
    className: "Ribbon ".concat(className || '')
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Left["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("figcaption", {
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Right["default"], {})]
  }));
};
var _default = Ribbon;
exports["default"] = _default;